import styled from "styled-components";
const BottomCardLineSecondChartWrapper = styled.div``;

export default BottomCardLineSecondChartWrapper;
